import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {Issue, IssuesFilters, IssueUi} from '@store/operations/issues/issues.model';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface IssuesState {
  filters: IssuesFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const issuesStore = createStore(
  {name: 'issues'},
  withProps<IssuesState>({
    filters: {search: '', tableFilters: IssuesFilters.initTableFilters()},
    sort: {
      field: 'issue.reportedAt',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Issue>(),
  withUIEntities<IssueUi>(),
  withPagination(),
  withRequestsStatus(),
);
